import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Copyright from '../common/Copyright';
import BasicData from './BasicData';
import Description from './Description';
import { CompanyForm } from '../../models/company.model';
import MainContainer from '../common/MainContainer';
import FormSection, { FormConfirm, FormElement } from '../common/FormSection';
import AlertMessage from '../common/AlertMessage';
import ActionButton from '../common/ActionButton';
import { useNotification } from '../../context/NotificationContext';


interface HandleFormProps {
  action: string
  handleChange: (e: any) => void
  onSubmit: (p: any) => void
  companyForm: any
  setBlockScreen: (p: boolean) => void
  selectedProject: string
}

export default function HandleForm({
  action,
  setBlockScreen,
  handleChange,
  onSubmit,
  companyForm }: HandleFormProps) {

  const { showNotification } = useNotification();
  const { handleSubmit } = useForm<CompanyForm>()
  const requiredFields = [
    'name',
  ]

  const initComponent = () => {
    if (action === 'create' || action === 'edit') {
      setBlockScreen(true)
      Promise.all([
      ]).then(function () {
        setTimeout(() => setBlockScreen(false), 200)
      }).catch((error) => {
        showNotification(error.response.data)
        setBlockScreen(false)
      });
    }
  }

  useEffect(initComponent, [action])

  const formValidator = () => {
    return requiredFields.some((key) => !companyForm[key] || Object.keys(companyForm[key]).length === 0)
  }

  return (
    <React.Fragment>
      <MainContainer>
        <FormSection>

          <FormElement>
            <BasicData
              action={action}
              handleChange={handleChange}
              companyForm={companyForm}
            />
          </FormElement>

          <FormElement>
            <Description
              action={action}
              handleChange={handleChange}
              companyForm={companyForm}
            />
          </FormElement>

          {(action === 'create' || action === 'edit') && (

            <FormConfirm>
              <div className='text-secondary'>
                <p>
                  (*) Campos requeridos
                </p>
              </div>

              {(formValidator()) && (
                <div>
                  <AlertMessage
                    severity='error'
                    message='Hay campos requeridos sin completar' />
                </div>
              )}

              <div>
                <ActionButton
                  text='Confirmar'
                  type='confirm'
                  onClick={handleSubmit(onSubmit)}
                  disabled={formValidator()}
                />
              </div>

            </FormConfirm>
          )}
        </FormSection>
      </MainContainer>
      <Copyright />
    </React.Fragment >
  );
}
